import { render } from "./ServiceItsShowcaseCardComp.vue?vue&type=template&id=2c0c926d&scoped=true"
import script from "./ServiceItsShowcaseCardComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsShowcaseCardComp.vue?vue&type=script&lang=js"

import "./ServiceItsShowcaseCardComp.vue?vue&type=style&index=0&id=2c0c926d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0c926d"]])

export default __exports__